import { toCart } from './toCart';
import { toCheckout } from './toCheckout';
import { toThankYouPage } from './toThankYouPage';
export var createNavigateExports = function (_a) {
    var context = _a.context, origin = _a.origin;
    return {
        toCart: toCart({ context: context, origin: origin }),
        toCheckout: toCheckout({ context: context, origin: origin }),
        toThankYouPage: toThankYouPage({ context: context, origin: origin }),
    };
};
//# sourceMappingURL=wixcode.navigate.js.map